export const fingerprint = 'ProfileContainer';
export const meta = { fingerprint };
